module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10039.70479cc5.jpg";